export const ALLOWED_STAYFLEXI_EMAILS = [
  "abhishek.kumar@stayflexi.com",
  "ankit.sinha@stayflexi.com",
  "arjun@stayflexi.com",
  "arjun.pandey@stayflexi.com",
  "arun.e@stayflexi.com",
  "chaitanya.yadav@stayflexi.com",
  "chandu.priya@stayflexi.com",
  "gaurav.haldiya@stayflexi.com",
  "kavyasri.b@stayflexi.com",
  "pavan.varanasi@stayflexi.com",
  "preetham.shetty@stayflexi.com",
  "sasank.talasila@stayflexi.com",
  "srinivasan@stayflexi.com",
  "venkatesh.sakamuri@stayflexi.com",
  "prabhat.chandra@stayflexi.com",
  "prabhat@stayflexi.com",
  "info@stayflexi.com",
  "nithin.ts@stayflexi.com",
  "bhausingh.garasiya@stayflexi.com",
  "anand.babu@stayflexi.com",
  "mahesh.babu@stayflexi.com",
  "aditi.pandey@stayflexi.com",
  "rohini.varma@stayflexi.com",
  "shobitha.kumari@stayflexi.com",
  "hanvitha.panthagani@stayflexi.com",
  "shwetha.m@stayflexi.com",
  "varun.bhatt@stayflexi.com",
  "kajal.rajkumari@stayflexi.com",
  // "vishnu.sagar@stayflexi.com", /* vishnu is not allowed for master login from now as prabhat asked to remove him from the list */
  "deepak.kumar@stayflexi.com",
  "yamini.sandra@stayflexi.com",
  "nivesh.reddy@stayflexi.com",
  "rajlaxi.rao@stayflexi.com",
  "priya.p@stayflexi.com",
  "vatsala.b@stayflexi.com"
];

export const isStayflexiEmailAllowed = (email) => {
  if (!email || typeof email !== "string") {
    return false;
  }

  const normalizedEmail = email.trim().toLowerCase();
  return ALLOWED_STAYFLEXI_EMAILS.includes(normalizedEmail);
};

export const formatDisplayTimeForOtpEpoch = (otpExpiresAt) => {
  if (!otpExpiresAt || otpExpiresAt <= 0) return "0:00";
  const remaining = otpExpiresAt - Math.floor(Date.now() / 1000);
  const mins = Math.max(0, Math.floor(remaining / 60));
  const secs = Math.max(0, remaining % 60);
  return `${mins}:${secs.toString().padStart(2, "0")}`;
};
